'use strict';

var _ = require('lodash');
var d3 = require('d3');
var Scales = function Scales(params, data, range) {
  /**
   * In case when there's no d.m3 or d.m4 use zero (ex. postDepartureMode)
   * @param d
   * @returns {Array}
   */
  var yMin = d3.min(data, function (d) {
    return _.min([0, d.m1, d.m2, d.m3, d.m4]);
  });
  var yMax = d3.max(data, function (d) {
    return _.max([0, d.m1, d.m2, d.m3, d.m4]);
  });

  // the brush can modify the visible range of elements
  data = data.slice(range[0], range[1]);
  function calculateWidth() {
    var width = params.width;
    var dataLength = data.length;
    if (params.width / dataLength > params.maxGroupWidth) {
      width = params.maxGroupWidth * dataLength;
    }
    return width;
  }
  var width = calculateWidth();
  var offset = (params.width - width) / 2;
  var x = d3.scale.ordinal().domain(_.map(data, 'departureDateMoment')).rangeBands([offset, width + offset], 0.1, 0.05);
  var y = d3.scale.linear().domain([yMin, yMax]).range([params.height, 0]);
  return {
    xScale: x,
    yScale: y
  };
};
Scales.$inject = [];
module.exports = Scales;